import { render, staticRenderFns } from "./joinStart.vue?vue&type=template&id=c2745860&scoped=true"
import script from "./joinStart.vue?vue&type=script&lang=js"
export * from "./joinStart.vue?vue&type=script&lang=js"
import style0 from "./joinStart.vue?vue&type=style&index=0&id=c2745860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2745860",
  null
  
)

export default component.exports